import { Directive, ElementRef, EventEmitter, Output } from "@angular/core";


@Directive({
  selector: '[clickOutside]',
  outputs: ['clickOutside'],
  host: {
    '(document: click)': 'handleClick($event)',
    '(document: touchend)': 'handleClick($event)'
  }
})
export class ClickOutsideDirective {
  
  @Output('clickOutside') emitter: EventEmitter<void> = new EventEmitter<void>(); 

  constructor(private _eref: ElementRef) {}
  
  handleClick(event){
    if (!this._eref.nativeElement.contains(event.target)) {
      event.stopPropagation();
      this.emitter.emit();
    }
  }  
  
}



// WEBPACK FOOTER //
// ./src/directives/click.outside.directive.ts